import {apiGet} from './client';

export function getPlans(product) {
    const qs = product ? `?product=${encodeURIComponent(product)}` : '';
    return apiGet(`/celebs/plans${qs}`);
}
